var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row h-100"},[_c('div',{staticClass:"col-md-12 h-100"},[_c('router-view',{staticClass:"h-100"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }